import { ref, computed, getCurrentInstance } from 'vue';
import { config } from '@/config';

export function usePosiciones() {
    const { proxy: { $store, $toast } } = getCurrentInstance();

    const loading = ref(false);
    const posiciones = ref([]);

    const teatro = computed(() => $store.getters.getTeatro);

    async function fetchPosiciones() {
        loading.value = true;
        try {
            const res = await $store.dispatch(config.getVuexAlias('back.teatro.posiciones.index'), {
                teatro_id: teatro.value.id,
                filters: {}
            });
            posiciones.value = res.data.data;
        } catch (error) {
            $toast.error(error.response?.data?.message || 'Error al cargar posiciones');
        } finally {
            loading.value = false;
        }
    }

    return {
        posiciones,
        loading,
        fetchPosiciones
    };
}